<div class="h-full">
  <div class="my-2 flex flex-row justify-end">
    <button
      class="btn btn-primary btn-sm mx-2"
      (click)="download(downloadLink(), chapterTitle(), documentType())"
    >
      <ng-icon name="lucideDownload"></ng-icon>
      {{ "instruction.chapter-detail.download" | translate }}
    </button>
  </div>
  @if (documentType() == "pdf") {
    <app-paged-pdf-viewer
      [pdfUrl]="downloadLink()"
      tailwindBreakpoint
      (documentResized)="handleDocumentResized($event)"
      [minHeight]="pdfMinHeight()"
      [showPageNumberOnLastPage]="
        !canConfirm() || currentChapterConfirmation() != undefined
      "
    >
      @if (canConfirm() && currentChapterConfirmation() == undefined) {
        <button
          class="btn btn-primary"
          (click)="confirmationDialog.showModal()"
        >
          {{ "common.confirm" | translate }}
        </button>
      }
    </app-paged-pdf-viewer>
  }
  @if (documentType() == "video") {
    <app-video-player
      [video]="video()"
      [canShowConfirmation]="
        canConfirm() && currentChapterConfirmation() == undefined
      "
      (confirm)="confirmationDialog.showModal()"
      [confirmButtonText]="'common.confirm' | translate"
    >
      <button class="btn btn-primary" (click)="confirmationDialog.showModal()">
        {{ "common.confirm" | translate }}
      </button>
    </app-video-player>
  }
</div>

<dialog class="modal" #confirmationDialog>
  <div class="modal-box">
    <h3 class="text-lg font-bold">
      {{ "instruction.chapter-detail.confirmation-dialog.title" | translate }}
    </h3>
    <p class="py-4 text-gray-600">
      {{ "instruction.chapter-detail.confirmation-dialog.content" | translate }}
    </p>

    @if (isConfirmingChapter()) {
      <app-loading-indicator></app-loading-indicator>
    } @else {
      <app-chapter-quizz
        [questions]="questions().questions"
        (questionsAnswered)="questionsAnswered($event)"
      ></app-chapter-quizz>
    }

    <div class="modal-action">
      <button class="btn" (click)="closeDialog()">
        {{ "common.cancel" | translate }}
      </button>
    </div>
  </div>
</dialog>
